import { Edge, Node, NodeProps, useReactFlow } from 'reactflow';

import { uuid } from '../utils';

// this hook implements the logic for clicking a placeholder node
// on placeholder node click: turn the placeholder and connecting edge into a workflow node
export function usePlaceholderClick(id: NodeProps['id']) {
  const { getNode, setNodes, setEdges } = useReactFlow();

  const handleClick = (selectedType: string | null, childCount?: number, useParentNodeType: boolean = false) => {

    if (!selectedType) {
      return;
    }
    // we need the parent node object for getting its position
    const parentNode = getNode(id);
    if (!parentNode) {
      return;
    }

    const isPlaceHolderRequired: boolean = !(selectedType === 'evaluatorNode' && !childCount);

    const newNodes: Node[] = [];
    const newEdges: Edge[] = [];

    for (let i = 1; i <= (childCount || 1); i++) {
      // create a unique id for the placeholder node that will be added as a child of the clicked node
      const childPlaceholderId = uuid();

      // create a placeholder node that will be added as a child of the clicked node
      const childPlaceholderNode = {
        id: childPlaceholderId,
        // the placeholder is placed at the position of the clicked node
        // the layout function will animate it to its new position
        position: { x: parentNode.position.x, y: parentNode.position.y },
        type: 'placeholder',
        data: { label: '+' },
      };

      // we need a connection from the clicked node to the new placeholder
      const childPlaceholderEdge = {
        id: `${parentNode.id}=>${childPlaceholderId}`,
        source: parentNode.id,
        target: childPlaceholderId,
        type: 'placeholder',
      };

      newNodes.push(childPlaceholderNode);
      newEdges.push(childPlaceholderEdge);
    }

    setNodes((nodes) =>
      nodes
        .map((node) => {
          // here we are changing the type of the clicked node from placeholder to the selected type
          if (node.id === id) {
            return {
              ...node,
              // type: selectedType,
              ...(useParentNodeType ? {} : { type: selectedType }),
              // data: { label: randomLabel() },
              // data: undefined,
            };
          }
          return node;
        })
        // add the new placeholder node
        .concat(isPlaceHolderRequired ? newNodes : [])
    );

    setEdges((edges) =>
      edges
        .map((edge) => {
          // here we are changing the type of the connecting edge from placeholder to workflow
          if (edge.target === id) {
            return {
              ...edge,
              type: 'workflow',
            };
          }
          return edge;
        })
        // add the new placeholder edge
        .concat(isPlaceHolderRequired ? newEdges : [])
    );
  };

  return handleClick;
}

export default usePlaceholderClick;